// generated in build: do not edit
export const version: string = '0.3.25';
export default version;
